import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Button, Tooltip } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { StyledPlaybookWizardFooterContent } from "./styles";

export type PlaybookWizardFooterProps = {
    isFirstStep: boolean;
    isLastStep: boolean;
    isCurrentStepValid: boolean;
    isSubmitting: boolean;
    primaryLabel: string;
    primaryDisabledTooltip?: string;
    onCancel: () => void;
    onBack: () => void;
    onPrimary: () => void;
};

export const PlaybookWizardFooter = ({
    isFirstStep,
    isLastStep,
    isCurrentStepValid,
    isSubmitting,
    primaryLabel,
    primaryDisabledTooltip,
    onCancel,
    onBack,
    onPrimary,
}: PlaybookWizardFooterProps) => {
    const { translate } = useTranslate();

    const showPrimaryTooltip = !isCurrentStepValid && !isSubmitting && !!primaryDisabledTooltip;

    return (
        <Flex
            width="100vw"
            margin="0 0 0 calc(-50vw + 50%)"
            background={colorsPalettes.carbon["0"]}
            borderTop={`1px solid ${colorsPalettes.carbon["100"]}`}
            position="sticky"
            bottom="0"
            zIndex={1}
        >
            <StyledPlaybookWizardFooterContent
                width="100%"
                height="68px"
                margin="0 auto"
                gap="4px"
                alignItems="center"
                boxSizing="border-box"
            >
                <Button
                    type="flat"
                    onClick={onCancel}
                    isDisabled={isSubmitting}
                    dataAutomation="playbook-wizard-cancel"
                >
                    {translate("si.common.button.cancel")}
                </Button>
                <Flex flex="1" />
                {!isFirstStep ? (
                    <Button
                        type="flat"
                        onClick={onBack}
                        isDisabled={isSubmitting}
                        dataAutomation="playbook-wizard-back"
                    >
                        {translate("si.common.button.back")}
                    </Button>
                ) : null}
                <Tooltip
                    content={primaryDisabledTooltip ?? ""}
                    enabled={showPrimaryTooltip}
                >
                    <Button
                        type="primary"
                        onClick={onPrimary}
                        isDisabled={!isCurrentStepValid || isSubmitting}
                        isLoading={isLastStep ? isSubmitting : false}
                        dataAutomation="playbook-wizard-next"
                    >
                        {primaryLabel}
                    </Button>
                </Tooltip>
            </StyledPlaybookWizardFooterContent>
        </Flex>
    );
};
